<template>
  <section class="member-panel vip-overview">
    <header v-if="!data" class="member-panel-heading"><h1>VIP特权</h1><button class="reference-link" @click="navigate('/member/vip')">晋级彩金 ›</button></header>
    <PageState v-if="!isLoggedIn" title="登录后查看VIP特权" description="查询您的等级、进度和专属礼遇"><button class="primary" @click="openAuth('login')">登录</button></PageState>
    <PageState v-else-if="loading || error" :loading="loading" :error="error" @retry="load" />
    <template v-else-if="data">
      <template v-if="isDetails"><section class="vip-details-page"><header><button class="reference-link" @click="navigate('/mine/vip')">‹</button><h1>VIP详情</h1></header><div v-if="carouselLevels.length" class="vip-level-carousel" aria-label="VIP等级说明"><button class="vip-carousel-prev" aria-label="上一等级" @click="changeLevel(-1)">‹</button><article v-for="slide in levelSlides" :key="slide.position" :class="`vip-level-card position-${slide.position}`" :style="{backgroundImage:`url(${referenceAsset('vip-levels','card')})`}"><h2>{{ slide.level.levelName }}</h2><div class="vip-card-symbol"><img v-if="levelIcon(slide.level)" :src="levelIcon(slide.level)" alt="" /><span v-else>{{ slide.level.rankNo }}</span></div><div><p><b>{{ formatVipThreshold(slide.level.turnoverThreshold) }}</b><span>有效流水</span></p><p><b>{{ formatVipThreshold(slide.level.retentionTurnover) }}</b><span>保级流水</span></p></div></article><button class="vip-carousel-next" aria-label="下一等级" @click="changeLevel(1)">›</button></div><nav class="vip-carousel-dots" aria-label="选择VIP等级"><button v-for="level in carouselLevels" :key="level.levelId" :aria-label="level.levelName" :aria-current="level.levelId===selectedId?'true':undefined" :class="{active:level.levelId===selectedId}" @click="selectedId=level.levelId"></button></nav></section><section class="vip-details-table"><h2>VIP返水比例</h2><div class="record-table-scroll"><table class="record-table"><thead><tr><th>VIP等级</th><th v-for="level in data.levels || []" :key="level.levelId">{{ level.levelName }}</th></tr></thead><tbody><tr><td>默认返水</td><td v-for="level in data.levels || []" :key="level.levelId">{{ vipDefaultRebateRate(level.rebateRules) == null ? '—' : `${vipDefaultRebateRate(level.rebateRules)}%` }}</td></tr></tbody></table></div></section><section class="vip-details-table"><h2>VIP等级规则</h2><div class="record-table-scroll"><table class="record-table"><thead><tr><th>等级</th><th>累计存款门槛</th><th>有效流水门槛</th><th>保级流水</th><th>每日取款次数</th><th>每日取款总额度</th></tr></thead><tbody><tr v-for="level in data.levels || []" :key="level.levelId"><td>{{ level.levelName }}</td><td>{{ level.depositThreshold }}</td><td>{{ level.turnoverThreshold }}</td><td>{{ level.retentionTurnover }}</td><td>{{ level.dailyWithdrawalCount }}</td><td>{{ level.dailyWithdrawalLimit }}</td></tr></tbody></table></div></section></template><template v-else>
      <section class="vip-current"><div class="vip-medal" aria-hidden="true"><img v-if="currentLevelIcon" class="vip-medal-reference" :src="currentLevelIcon" alt="" /><template v-else><i></i><span>VIP<b>{{ String(data.levelName || '').replace(/\D/g,'') || '0' }}</b></span></template></div><div><h1>当前等级: {{ data.levelName || '--' }}</h1><p>流水：¥{{ data.currentTurnover }}</p></div><button class="primary" @click="navigate('/mine/vip/details')">查看VIP详情</button></section>
      <nav class="vip-level-tabs" aria-label="VIP等级"><button v-for="level in data.levels || []" :key="level.levelId" :class="{active:selectedId===level.levelId}" @click="selectedId=level.levelId">{{ level.levelName }}</button></nav>
      <section class="vip-next-level"><p>{{ data.nextLevelName?`距离下一等级：${data.nextLevelName}`:'当前已达到最高等级' }}</p><div><span>流水</span><div class="vip-progress" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100" aria-label="晋级进度"><i :style="{width:`${progress}%`}"></i></div><span>晋级进度 {{ data.progressRate || '0' }}%</span></div></section>
      <template v-if="selected"><div class="member-section-heading"><h2>{{ selected.levelName }}尊享</h2><button class="reference-link" @click="navigate('/mine/vip/details')">查看VIP详情</button></div><div class="vip-benefits"><article v-for="(item,index) in benefits" :key="item.label"><span class="vip-benefit-icon"><img :src="referenceAsset('vip-benefits',index)" alt="" /></span><strong>{{ item.value ?? '--' }}</strong><span>{{ item.label }}</span></article></div></template>
      <div class="vip-entry-links"><button @click="navigate('/member/vip')"><b>晋级彩金</b><span>查看各等级规则及申请记录 ›</span></button><button @click="navigate('/member/gift')"><b>晋级豪礼</b><span>查看礼品与物流信息 ›</span></button><button @click="navigate('/mine/rebate')"><b>实时返水</b><span>查看当前返水及规则 ›</span></button></div>
      <section v-if="privileges.length" class="vip-extra-privileges" aria-labelledby="vip-privileges-title">
        <h2 id="vip-privileges-title">更多VIP特权</h2>
        <div class="vip-privilege-grid">
          <article v-for="(item, index) in privileges" :key="item.code || index" class="vip-privilege-card">
            <span class="vip-privilege-icon"><SiteIcon name="gift" :size="22" /></span>
            <div class="vip-privilege-copy">
              <h3 v-if="item.name">{{ item.name }}</h3>
              <strong v-if="item.value != null && item.value !== ''">{{ item.value }}</strong>
              <p v-if="item.description">{{ item.description }}</p>
            </div>
          </article>
        </div>
      </section>
      </template>
      <p v-if="ruleError" class="field-error" role="alert">{{ ruleError }}</p>
      <section v-if="ruleRows.length" class="vip-rule-list" aria-labelledby="vip-rule-title">
        <header class="vip-rule-heading">
          <span class="vip-rule-icon" aria-hidden="true">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="3" width="14" height="18" rx="2" /><path d="M9 8h6M9 12h6M9 16h4" /></svg>
          </span>
          <div><h2 id="vip-rule-title">VIP活动规则</h2><p>会员权益与等级规则说明</p></div>
        </header>
        <ol class="vip-rule-body">
          <li v-for="(rule, index) in ruleRows" :key="`${rule.sortNo}-${index}`" class="vip-rule-item">
            <span class="vip-rule-index" aria-hidden="true">{{ String(index + 1).padStart(2, '0') }}</span>
            <div class="help-rich-text vip-rule-content" v-html="sanitizeHelpContent(rule.content)"></div>
          </li>
        </ol>
      </section>
    </template>
  </section>
</template>
<script setup>
import { computed, onBeforeUnmount, ref, watch } from 'vue'
import { webApi } from '../../services/webApi'
import { useAppContext } from '../../composables/appContext'
import { readVipActivityRules } from '../../services/vipActivityRules.js'
import PageState from '../feedback/PageState.vue'
import SiteIcon from '../SiteIcon.vue'
import { referenceAsset } from '../../config/referencePresentation.js'
import { vipDefaultRebateRate, formatVipThreshold } from '../../utils/vipPresentation.js'
const { currentPath, isLoggedIn, navigate, openAuth, sanitizeHelpContent } = useAppContext()
const data = ref(null), privileges = ref([]), loading = ref(false), error = ref(''), selectedId = ref(0)
const isDetails=computed(()=>currentPath.value==='/mine/vip/details')
const carouselLevels=computed(()=>{const all=data.value?.levels || [];const levels=all.filter(level=>Number(level.rankNo)>0);return levels.length?levels:all})
const levelSlides=computed(()=>{const levels=carouselLevels.value;if(!levels.length)return [];const index=Math.max(0,levels.findIndex(level=>level.levelId===selectedId.value));return [-1,0,1].map(position=>({position:position+1,level:levels[(index+position+levels.length)%levels.length]}))})
function changeLevel(direction){const levels=carouselLevels.value;if(!levels.length)return;const index=Math.max(0,levels.findIndex(level=>level.levelId===selectedId.value));selectedId.value=levels[(index+direction+levels.length)%levels.length].levelId}
watch([isDetails,()=>data.value?.levels],()=>{if(data.value)selectedId.value=isDetails.value?(carouselLevels.value[0]?.levelId || data.value.levelId):data.value.levelId})
let version = 0
const selected = computed(() => data.value?.levels?.find(level => level.levelId === selectedId.value))
function levelIcon(level){return level?.iconUrl || referenceAsset('vip-levels',Number(level?.rankNo))}
const currentLevelIcon=computed(()=>levelIcon(data.value?.levels?.find(level=>level.levelId===data.value?.levelId)) || referenceAsset('vip-levels',String(data.value?.levelName || '').replace(/\D/g,'')))
const progress = computed(() => Math.max(0, Math.min(100, Number(data.value?.progressRate) || 0)))
const benefits = computed(() => [
  { label: '每日提款次数', icon:'credit-card-outline', value: selected.value?.dailyWithdrawalCount },
  { label: '每日提款总额度', icon:'arrow-circle-down', value: selected.value?.dailyWithdrawalLimit },
  { label: '升级礼金', icon:'diamond', value: selected.value?.upgradeBonus },
  { label: '生日礼金', icon:'gift', value: selected.value?.birthdayBonus },
  { label: '每周红包', icon:'money', value: selected.value?.weeklyBonus },
])
const ruleState = computed(() => { try { return { rows: readVipActivityRules(data.value?.rules), error: '' } } catch (e) { return { rows: [], error: e.message } } })
const ruleRows = computed(() => ruleState.value.rows)
const ruleError = computed(() => ruleState.value.error)
async function load() {
  const ticket = ++version
  if (!isLoggedIn.value) { data.value = null; privileges.value = []; loading.value = false; return }
  loading.value = true; error.value = ''
  try {
    const [detail, extras] = await Promise.all([webApi.vipDetail(), webApi.vipPrivileges()])
    if (ticket !== version) return
    data.value = detail; privileges.value = extras || []; selectedId.value = detail.levelId
  } catch (e) { if (ticket === version) { data.value = null; privileges.value = []; error.value = e.message || 'VIP信息加载失败' } }
  finally { if (ticket === version) loading.value = false }
}
watch(isLoggedIn, load, { immediate: true })
onBeforeUnmount(() => { version++ })
</script>

<style scoped>
.vip-extra-privileges {
  margin-top: 16px;
  padding: 22px 24px 24px;
  border-radius: 12px;
  background: #fff;
}
.vip-extra-privileges > h2 {
  margin: 0 0 18px;
  color: #303442;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}
.vip-privilege-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 190px), 1fr));
  gap: 12px;
}
.vip-privilege-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border: 1px solid #edf1f7;
  border-radius: 10px;
  background: #f8fafd;
}
.vip-privilege-icon,
.vip-rule-icon {
  display: grid;
  flex: none;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  color: #509feb;
  background: #eaf3fe;
}
.vip-privilege-copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 6px;
  overflow-wrap: anywhere;
}
.vip-privilege-copy h3 {
  margin: 0;
  color: #424b60;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
}
.vip-privilege-copy strong {
  color: #303442;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
}
.vip-privilege-copy p {
  margin: 0;
  color: #778298;
  font-size: 13px;
  line-height: 1.75;
}
.vip-rule-list {
  margin-top: 16px;
  padding: 22px 24px 24px;
  border: 1px solid #e9edf5;
  border-radius: 12px;
  background: #fff;
}
.vip-rule-heading {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 18px;
  border-bottom: 1px solid #edf0f6;
}
.vip-rule-heading h2 {
  margin: 0;
  color: #303442;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
}
.vip-rule-heading p {
  margin: 3px 0 0;
  color: #8b95a8;
  font-size: 12px;
  line-height: 18px;
}
.vip-rule-body {
  margin: 0;
  padding: 18px 0 0;
  list-style: none;
}
.vip-rule-item {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  align-items: start;
  gap: 14px;
  min-width: 0;
}
.vip-rule-item + .vip-rule-item {
  margin-top: 18px;
  padding-top: 18px;
  border-top: 1px solid #edf0f6;
}
.vip-rule-index {
  display: grid;
  place-items: center;
  height: 28px;
  border-radius: 8px;
  color: #5795d5;
  font-size: 12px;
  font-weight: 600;
  background: #f0f5fc;
}
.vip-rule-content {
  min-width: 0;
  color: #68738a;
  font-size: 14px;
  line-height: 1.85;
  overflow-x: auto;
  overflow-wrap: anywhere;
}
.vip-rule-content :deep(h1),
.vip-rule-content :deep(h2),
.vip-rule-content :deep(h3),
.vip-rule-content :deep(h4),
.vip-rule-content :deep(h5),
.vip-rule-content :deep(h6) {
  margin: 20px 0 10px;
  color: #424b60;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.6;
}
.vip-rule-content :deep(p) {
  margin: 0 0 12px;
  color: inherit;
  line-height: inherit;
}
.vip-rule-content :deep(ul),
.vip-rule-content :deep(ol) {
  margin: 0 0 12px;
  padding-left: 22px;
}
.vip-rule-content :deep(li + li) {
  margin-top: 8px;
}
.vip-rule-content :deep(table) {
  width: 100%;
  margin: 12px 0;
  border-collapse: collapse;
}
.vip-rule-content :deep(th),
.vip-rule-content :deep(td) {
  padding: 10px 14px;
  border: 1px solid #e9edf5;
  text-align: left;
}
.vip-rule-content :deep(th) {
  color: #424b60;
  font-weight: 500;
  background: #f7f9fd;
}
.vip-rule-content :deep(> :first-child) {
  margin-top: 0;
}
.vip-rule-content :deep(> :last-child) {
  margin-bottom: 0;
}
@media (max-width: 767px) {
  .vip-extra-privileges,
  .vip-rule-list {
    padding: 18px 16px 20px;
  }
  .vip-rule-heading {
    padding-bottom: 14px;
  }
  .vip-rule-heading h2 {
    font-size: 16px;
    line-height: 24px;
  }
  .vip-rule-body {
    padding-top: 16px;
  }
  .vip-rule-item {
    grid-template-columns: 24px minmax(0, 1fr);
    gap: 10px;
  }
  .vip-rule-index {
    height: 24px;
  }
}
</style>
